import React from 'react'
import { bool, node } from 'prop-types'
import classnames from 'classnames'

const Fade = ({ active, children }) => {
  const classNameVal = classnames('animista', {
    'fade-in': active,
    'fade-out': !active,
  })
  return (
    <div className={classNameVal}>
      {children}
      <style jsx>
        {`
          .fade-in {
            animation: fade-in 1.2s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
          }
          @keyframes fade-in {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }
          .fade-out {
            animation: fade-out 1s ease-out both;
          }
          @keyframes fade-out {
            0% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }

        `}
      </style>
    </div>
  )
}

Fade.propTypes = {
  active: bool.isRequired,
  children: node.isRequired,
}

export default Fade
